import React from 'react';
import logo from 'assets/can-store/modernTemplate/logo.png';

import ModernSearchBar from 'containers/can-store/modernTemplate/ModernSearchBar';

import Box from '@mui/material/Box';

import ModernHeaderIconButtons from 'containers/can-store/modernTemplate/ModernHeaderIconButtons';

function ModernHeader(): JSX.Element {
	return (
		<Box component="section" sx={{ display: 'flex', justifyContent: 'space-between' }}>
			<Box
				component="img"
				src={logo}
				alt="Logo"
				loading="lazy"
				sx={{ width: '10rem', cursor: 'pointer' }}
			/>
			<ModernSearchBar />
			<ModernHeaderIconButtons />
		</Box>
	);
}

export default ModernHeader;
